import { getProductVariantBySessionItemId, selectedProductValuesToProduct } from "../cores/appCore";
import { getSelectedShipmentSolution } from "../cores/shipment.core";
import { isComplaintSelected, isExchangeSelected, isResaleSelected, isReturnSelected } from "../cores/selectedProductValuesCore";

export default function refundCalculateMockFn(props) {
    const { selectedProductsValues, loginServiceData, selectedShipmentSolutionData } = props;

    const currencyCode = loginServiceData?.data?.currencyCode || "EUR";

    let complaintExists = false;
    let exchangeExists = false;
    let returnExists = false;
    let lines = selectedProductsValues?.reduce((result, selectedProductValues) => {
        const productId = selectedProductValues.productId;
        const product = getProductVariantBySessionItemId({ loginServiceData }, productId);
        if (isComplaintSelected(selectedProductValues)) {
            complaintExists = true;
        }
        if (isReturnSelected(selectedProductValues) || isComplaintSelected(selectedProductValues)) {
            result.push({
                type: "ITEM_REFUND",
                value: product?.purchasePrice,
                productVariantId: product?.productVariantId,
            });
        }
        if (isResaleSelected(selectedProductValues)) {
            result.push({
                type: "ITEM_RESALE",
                value: selectedProductValues?.price,
                productVariantId: product?.productVariantId,
            });
        }

        if (isExchangeSelected(selectedProductValues)) {
            const swapProduct = selectedProductValues?.swapProduct;
            const product = selectedProductValuesToProduct(props, selectedProductValues);
            if (swapProduct) {
                result.push({
                    type: "ITEM_REFUND",
                    value: product?.purchasePrice - swapProduct?.purchasePrice,
                    productVariantId: product?.productVariantId,
                });
            }
            exchangeExists = true;
        }
        if (isReturnSelected(selectedProductValues)) {
            returnExists = true;
        }
        return result;
    }, []);

    if (complaintExists && loginServiceData?.data?.paidShipping) {
        lines.push({
            type: "SHIPPING_REFUND",
            value: loginServiceData?.data?.paidShipping,
        });
    }

    if (returnExists && !complaintExists && !exchangeExists && loginServiceData?.data?.turnrShippingCost) {
        lines.push({
            type: "RETURN_HANDLING_COST",
            value: loginServiceData?.data?.returnHandlingCost || -79,
        });
    }

    if (selectedShipmentSolutionData) {
        const shippingRefundLine = lines.find((line) => line.type === "RETURN_COST");
        const pickupMethodCost = -getSelectedShipmentSolution({
            loginServiceData,
            selectedShipmentSolutionData,
        })?.cost;
        if (shippingRefundLine) {
            shippingRefundLine.value = pickupMethodCost;
        } else {
            if (pickupMethodCost) {
                lines.push({ type: "RETURN_COST", value: pickupMethodCost });
            }
        }
    }

    if (selectedProductsValues?.length === 0) {
        lines = [];
    }

    const totalAmount = lines.reduce((result, line) => result + line.value, 0);
    return {
        refundOptions: ["BASIC", "GIFT_CARD"],
        refund: {
            currencyCode: currencyCode,
            lines: lines,
            totalAmount: totalAmount,
        },
        giftCardBonus: 0.2,
    };
}
